import React from 'react';
import T from 'prop-types';
import styled from 'styled-components';
import { Button } from '@acast/decibel';
import { PlaySolidGlyph, PauseSolidGlyph } from '@acast/decibel-glyphs';
import { formatTime } from 'shared/helpers/time';

const RoundButton = styled(Button)`
  border-radius: 50%;
`;

const PlaybackButton = ({ isLoading, isPlaying, onPlay, onPause }) => {
  const baseClassName = 'editor-controls__item-container';
  if (isLoading) {
    return (
      <div className={`${baseClassName} spinner-button`}>
        <div className="acast-progress-spinner dark" />
      </div>
    );
  }

  if (isPlaying) {
    return (
      <RoundButton
        variant="secondary"
        className={`${baseClassName} pause-button`}
        onClick={onPause}
        glyph={PauseSolidGlyph}
      />
    );
  }

  return (
    <RoundButton
      variant="secondary"
      className={`${baseClassName} play-button`}
      onClick={onPlay}
      glyph={PlaySolidGlyph}
    />
  );
};

PlaybackButton.propTypes = {
  isLoading: T.bool.isRequired,
  isPlaying: T.bool.isRequired,
  onPlay: T.func.isRequired,
  onPause: T.func.isRequired,
};

const PlaybackControls = ({ audioProgress, ...restProps }) => (
  <>
    <PlaybackButton {...restProps} />
    <div className="editor-controls__item-container audio-progress">
      <div>{formatTime(audioProgress)}</div>
    </div>
  </>
);

PlaybackControls.propTypes = {
  audioProgress: T.number.isRequired,
};

export default PlaybackControls;
